import React from 'react';
import './style.css';
import clsx from 'clsx';

function Input(props) {
  const {
    placeholder = 'placeholder',
    title = 'title',
    name = 'name',
    id = 'id',
    error,
    type = 'text',
    onChange = () => { },
    value,
    className,
    onKeyPress,
    onMouseDown,
    onFocus,
    disable,
    onBlur,
    ref,
    required = false,
    maxLength,
    padding,
    labelStyle,
    noLabel = false
  } = props;

  return (
    <div className={`input-main-div ${className}`}>
      {!noLabel && (
        <div className="Input-headingcontainer">
          <label style={labelStyle} className="input-div">
            {title}
          </label>
        </div>
      )}

      <input
        style={{ padding: padding }}
        type={type}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === ' ' && value.length === 0) {
            e.preventDefault(); // ✅ Prevent first character from being a space
          }
        }}
        name={name}
        onMouseDown={onMouseDown}
        id={id}
        disabled={disable}
        className={clsx(className, 'input-new')}
        onChange={(e) => onChange(e)}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
        ref={ref}
        required={required}
        maxLength={maxLength}
      />
      {error && <p className="InputErrorMsg">{error}</p>}
    </div>
  );
}

export default Input;